export const ADD_PROCESSOR_OPTIONS = {
    inputFrameBufferType: "videoframe",
    outputFrameBufferContextType: "bitmaprenderer",
};

export const DEFAULT_PARAMS_VB = {
    blurFilterRadius: "15",
    capFramerate: "30",
    capResolution: "1280x720",
    deferInputFrameDownscale: "false",
    maskBlurRadius: "2",
    stats: "show",
    useWebWorker: "true",
    fillType: "Cover", // 'Cover' or 'Contain'. 'Cover' fills the entire area, 'Contain' fits the image without stretching.
};

export const assetsPath = window.location.origin + `${process.env.PUBLIC_URL}/scripts`;

export const PROCESSOR_OPTIONS = {
    assetsPath: assetsPath, // Leave empty or set a valid path if using custom model assets
    deferInputFrameDownscale: JSON.parse(DEFAULT_PARAMS_VB.deferInputFrameDownscale),
    maskBlurRadius: Number(DEFAULT_PARAMS_VB.maskBlurRadius),
    useWebWorker: JSON.parse(DEFAULT_PARAMS_VB.useWebWorker),
};

export const DEFAULT_VIRTUAL_BACKGROUND_IMAGES = [
    { id: "office", image: "/images/office.jpg" },
    { id: "homeBg", image: "/images/homeBg.jpg" },
    { id: "meetingRoomBg", image: "/images/meetingRoomBg.jpg" },
    { id: "cafeBlurryBg", image: "/images/cafeBlurryBg.jpg" },
    { id: "mallBlurryBg", image: "/images/mallBlurryBg.jpg" },
    { id: "colorBg", image: "/images/colorBg.jpg" },
    { id: "whiteBg", image: "/images/whiteBg.jpg" },
];

export const VIRTUAL_BACKGROUND = {
    MAX_SIZE: 10000000, // 10MB
    RECOMMENDED_IMAGE_WIDTH_DIMENSION: 1920,
    RECOMMENDED_IMAGE_HEIGHT_DIMENSION: 1080,
    LOCAL_IMAGE_ID: "LOCAL_IMAGE_ID",
    NONE_EFFECT_ID: "NONE_EFFECT_ID",
    BLUR_EFFECT_ID: "BLUR_EFFECT_ID",
    FROM_DRAG_IMAGE: "FROM_DRAG_IMAGE",
    ALLOWD_IMAGE_EXTENSIONS: ["jpg", "jpeg", "png"],
};
